module.exports = __webpack_public_path__ + "static/media/car.c81454e9.svg";